import styled from 'styled-components';

export default styled.div`
	--gap: var(--spacing-large);
	display: grid;
	grid-template-columns: auto 1fr;
	grid-template-rows: auto;
	gap: var(--gap);
	grid-template-areas:
		'filter search'
		'controls controls';
	padding: var(--v-pad) var(--h-pad);
	border-bottom: var(--px-1) solid var(--header--border-color);

	&.filters {
		grid-template-columns: auto auto 1fr;
		grid-template-areas:
		'filter search chips'
		'controls controls controls';
		.filter-chips {
			display: block;
		}
	}

	&.selected {
		grid-template-columns: auto auto 1fr;
		grid-template-areas:
			'filter search search'
			'select select controls';
		.filter-chips {
			display: none;
		}
		.controls {
			justify-content: end;
		}
	}

	&.filters.selected {
		grid-template-columns: auto auto 1fr;
		grid-template-areas:
			'filter search chips'
			'select select controls';
		.filter-chips {
			display: block;
		}
	}

	.filter-chips {
		display: none;
		grid-area: chips;
	}
	.filter {
		grid-area: filter;
	}
	.search {
		grid-area: search;
	}
	.controls {
		grid-area: controls;
	}
	.selection {
		grid-area: select;
	}
`;
